import { Domain, findDomainByText } from "../../apis/mgmt/api";
import { DataViewProps, useStatefulDataView } from "../common/DataView";
import { FilteredPaginatedListLayout, useApiTextFilteredList } from "../common/FilteredPaginatedList";
import { ListProps, useStatefulList } from "../common/List";
import { Paginator, PagingProps, useStatefulPaging } from "../common/Paging";
import { SimpleTextFilter } from "../common/SimpleTextFilter";
import { DomainList } from "./DomainList";

export const useDomainFilteredPaginated = function () {
    return useApiTextFilteredList<Domain>({
        filterProps: useStatefulDataView(''),
        listProps: useStatefulList<Domain>(),
        pagingProps: useStatefulPaging(),
        apiQueryFunc: findDomainByText
    });
};

export const DomainFilteredList = function (props:{
    filterProps: DataViewProps<string>,
    listProps: ListProps<Domain>,
    pagingProps: PagingProps
}) {

    const { filterProps, listProps, pagingProps} = props;
    
    return (
        <FilteredPaginatedListLayout
            filter={<SimpleTextFilter {...filterProps} />}
            list={<DomainList {...listProps} />}
            paginator={<Paginator {...pagingProps} />}
        />
    );

};
